/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Http } from '@angular/http'

import { Observable } from "rxjs/Observable";
import { Subscriber } from "rxjs/Subscriber";
import '@api/rxjs-operators';

import { Menu } from '@api/models/menu';
import { User } from '@api/models/user';

/**
 * Service to get and manage the menu for Connected Experience
 */
@Injectable()
export class MenuConnectedService {
    private menuUrl = "/serve/menu";
    // private menuUrl = "/api/experience";

    /**
     * Create the new instance of MenuService
     * @param http The instance of Http
     */
    constructor(private http: Http) {}

    /**
     * Return meu from backend and translate it into the array of Menus
     * @param user The authenticated user 
     */
    getMenus(user: User): Observable<Menu[]> {
        // return this.http.get(this.menuUrl)
        //     .map((response: any) => this.translateMenu(user, response.json()));
        return Observable.empty<Menu[]>();
    }

    private translateMenu(user: User, menu: any = {}): Menu[] {
        // Get portlets
        let portlets = menu.portlets;

        let menuItems: Menu[] = [];
        for (let i = 0, len = portlets.length; i < len; i++) {
            let menuRoute = portlets[i];
            for (let j = 0, componentLen = menuRoute.components.length; j < componentLen; j++) {
                let menuItem: Menu = {
                    title: menuRoute.components[j].title,
                    routerPath: (menuRoute.routerPath + '/' + menuRoute.components[j].routerPath).replace('//', '/'),
                    moduleUrl: menuRoute.moduleUrl,
                    icon: menuRoute.components[j].icon,
                    active: false, 
                    roles: menuRoute.components[j].roles
                }
                // if (this.isInRole(menuRoute.components[j].roles, user.roles) || menuRoute.components[j].roles.length === 0) {
                //     // Do not save duplicates
                //     if (menuItems.indexOf(menuItem) === -1) {
                //         menuItems.push(menuItem);
                //     }
                // }
                menuItems.push(menuItem);
            }
        }
        console.log('translateMenu', menuItems);
        return menuItems;
    }

    // private isInRole(componentRoles: any[], activeProfileRoles: any[]): boolean {
    //     if (componentRoles && componentRoles.length && activeProfileRoles && activeProfileRoles.length) {
    //         return activeProfileRoles.some(function (v) {
    //             return componentRoles.indexOf(v) >= 0;
    //         });
    //     }
    //     return false;
    // }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/menu-threshold.service.ts